export default "__VITE_ASSET__DO1nMUX$__"